module.exports = __webpack_public_path__ + "static/01-95c09b95c125140291d9b12a30038449.jpg";